import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-stack-line text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">久久综合</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              海量资源一站式聚合平台，汇集影视、音乐、图文、资讯等丰富资源，为您提供极致浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">关于久久综合</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-600">客服邮箱：support@jiujiuzonghe.com</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/70 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="RSS">
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 久久综合 JiujiuZongHe.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">使用条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}